import { KeywordFormData } from '../types';

const initKeyword: KeywordFormData = {
  Title: '',
  Instructions: '',
};

export default initKeyword;
